/**
 * Interface strings of the cabinet journeys pages (src/pages/journeys/*). Russian is the key.
 * Registered automatically by src/i18n/index.ts.
 */
export default {
  en: {
    '(обязательна в маркетинге)': '(required for marketing)',
    '(тема не отрисована)': '(subject not rendered)',
    '+{d} дн.': '+{d} d.',
    '+{h} ч': '+{h} h',
    '+{m} мин': '+{m} min',
    '1 ч → письмо → … — откройте любой сценарий и вкладку JSON.': '1 h → email → … — open any journey and its JSON tab.',
    '20 случайных': '20 random',
    '95 % интервал (Ньюкомб): {a} … {b}': '95 % interval (Newcombe): {a} … {b}',
    '95 % интервал (Уилсон)': '95 % interval (Wilson)',
    '95 % интервал: {a} … {b}': '95 % interval: {a} … {b}',
    'Created == false, если ничего не изменилось': 'Created == false if nothing changed',
    'Id шага': 'Step ID',
    'JSON (условия сценария)': 'JSON (journey conditions)',
    'JSON не разбирается — изменение не применено': 'Invalid JSON — the change was not applied',
    'email, external_id или con_…': 'email, external_id or con_…',
    'true, 42, «текст» или =путь': 'true, 42, «text» or =path',
    '{a} (не найден)': '{a} (not found)',
    '{g} из {e}': '{g} of {e}',
    '{label}: единица': '{label}: unit',
    '{n} в сегменте': '{n} in segment',
    '{n} изменение': '{n} change',
    '{n} изменений': '{n} changes',
    '{n} срабатываний за 7 дней': '{n} triggers in the last 7 days',
    '{p} % — писем не получат': '{p} % — will not get emails',
    '{state} v{av}. Участия в пути доходят по своей версии; новые — по v{v}.': '{state} v{av}. Enrollments in progress continue on their version; new ones on v{v}.',
    '{s}{v} % отн.': '{s}{v} % rel.',
    '{{свойство}} события; в письме — {{digest.items_text}} / {{{digest.items_html}}}': '{{property}} of the event; in the email — {{digest.items_text}} / {{{digest.items_html}}}',
    '«Загрузить их версию» заменит ваши несохранённые правки (вернуть их можно кнопкой «Отменить»). «Перезаписать моей» сохранит ваш вариант поверх.': '«Load their version» replaces your unsaved edits (you can get them back with «Discard changes»). «Overwrite with mine» saves your version on top.',
    'Адрес отправителя': 'Sender address',
    'Активна': 'Active',
    'Атрибут': 'Attribute',
    'Атрибут-дата': 'Date attribute',
    'Атрибутировано (не равно приросту)': 'Attributed (not equal to lift)',
    'Атрибуты контакта в теле': 'Contact attributes in the body',
    'Аудитория (оценка)': 'Audience (estimate)',
    'Без мыши: Tab — по шагам, A — добавить, C — соединить, M — переместить, ? — все клавиши. На телефоне удобнее «Список шагов».': 'Without a mouse: Tab — between steps, A — add, C — connect, M — move, ? — all keys. On a phone it is easier with «Step list».',
    'Без тихих часов': 'No quiet hours',
    'Ближайшее такое время в поясе контакта (переходы на летнее время учтены)': 'The nearest such time in the contact’s time zone (daylight saving changes are taken into account)',
    'В пространстве нет второго владельца или администратора': 'The workspace has no second owner or admin',
    'Вариант': 'Variant',
    'Вариант {id}: дальше': 'Variant {id}: next',
    'Вариант назначается детерминированно по контакту и сохраняется в участии.': 'The variant is assigned deterministically per contact and stored in the enrollment.',
    'Введите ключ сценария: {key}': 'Enter the journey key: {key}',
    'Вебхук ставится в очередь в транзакции шага; сценарий не ждёт ответа': 'The webhook is queued in the step transaction; the journey does not wait for a response',
    'Вернуть с комментарием': 'Return with a comment',
    'Версии': 'Versions',
    'Версии закреплены в хеше сценария: правка политики или шаблона потребует нового согласования.': 'Versions are pinned in the journey hash: editing the policy or template requires a new approval.',
    'Версий ещё нет.': 'No versions yet.',
    'Версия': 'Version',
    'Версия {v} ещё не согласована': 'Version {v} is not approved yet',
    'Версия опубликована; сценарий остаётся на паузе MailOcean': 'Version published; the journey stays paused by MailOcean',
    'Версия текста': 'Text version',
    'Версия шаблона не найдена.': 'Template version not found.',
    'Вес, %': 'Weight, %',
    'Возвращено автору с комментарием': 'Returned to the author with a comment',
    'Возобновить': 'Resume',
    'Вошёл': 'Entered',
    'Вошёл {dt}': 'Entered {dt}',
    'вошёл': 'entered',
    'вошёл {dt}': 'entered {dt}',
    'Время': 'Time',
    'Время контакта': 'Contact time',
    'Все сценарии': 'All journeys',
    'Все участия завершатся, ожидания и таймеры удалятся, письма сценария в очереди будут отменены. Вернуть нельзя — только создать новый сценарий.': 'All enrollments will end, waits and timers will be removed, and queued journey emails will be cancelled. This cannot be undone — only a new journey can be created.',
    'Вставить новый шаг сюда': 'Insert a new step here',
    'Вход контакта в сегмент запускает сценарий': 'A contact entering the segment starts the journey',
    'Вы автор этой версии: согласовать её должен другой владелец или администратор пространства.': 'You are the author of this version: another owner or admin of the workspace must approve it.',
    'Выберите участие слева — покажем каждый шаг с временем и исходом.': 'Select an enrollment on the left — we will show each step with its time and outcome.',
    'Выбрать контакты': 'Pick contacts',
    'Выбрать шаблон': 'Choose a template',
    'Выходить при достижении цели': 'Exit when the goal is reached',
    'Горизонт, дн.': 'Horizon, days',
    'Граф сценария в JSON': 'Journey graph in JSON',
    'Граф — JSON по схеме': 'Graph — JSON per the schema',
    'Группа': 'Group',
    'Дальше': 'Next',
    'Данных пока мало: выводы делать рано.': 'Not enough data yet: too early to draw conclusions.',
    'Дни недели': 'Days of the week',
    'До 24 ч': 'Up to 24 h',
    'До 90 дней': 'Up to 90 days',
    'До местного времени': 'To local time',
    'Добавить условие': 'Add condition',
    'Добавьте до 20 контактов.': 'Add up to 20 contacts.',
    'Доля': 'Share',
    'Допустимое опоздание, ч': 'Allowed lateness, h',
    'Доставка': 'Delivery',
    'Единица': 'Unit',
    'Если письмо пропущено': 'If the email is skipped',
    'Если событие пришло': 'If the event arrives',
    'Если тайм-аут': 'If timeout',
    'Есть несохранённые изменения': 'There are unsaved changes',
    'Есть несохранённый черновик': 'There is an unsaved draft',
    'Есть цель': 'Has a goal',
    'Ждать не дольше': 'Wait no longer than',
    'Ждёт решения владельца или администратора пространства.': 'Waiting for a decision from the workspace owner or an admin.',
    'Загружена их версия черновика': 'Their draft version loaded',
    'Загрузить их версию': 'Load their version',
    'Закрепляется при сохранении: одобряется ровно этот текст, правки шаблона потом его не меняют': 'Pinned on save: exactly this text is approved; later template edits do not change it',
    'Закрыть панель': 'Close panel',
    'Записать атрибуты': 'Set attributes',
    'Запрос на согласование отправлен': 'Approval request sent',
    'Запросил': 'Requested by',
    'Запросить согласование v{v}': 'Request approval for v{v}',
    'Запросить согласование может участник с ролью разработчика и выше.': 'Requesting approval is available to members with the developer role or higher.',
    'Запустить v{v}': 'Launch v{v}',
    'Запустить симуляцию': 'Run simulation',
    'Запущено: сценарий течёт': 'Launched: the journey is flowing',
    'Зачислен': 'Enrolled',
    'Зачислить': 'Enroll',
    'Зачислить контакт': 'Enroll contact',
    'Здесь появится «погружение капли»: путь каждого контакта по шагам с временем, исходами и письмами.': 'The «drop deep dive» appears here: the path of each contact through the steps, with timing, outcomes and emails.',
    'Значение {k}': 'Value {k}',
    'Значение или путь (contact.attributes.x, context.properties.y)': 'Value or path (contact.attributes.x, context.properties.y)',
    'Значение по умолчанию {name}': 'Default value for {name}',
    'Из шаблона': 'From template',
    'Изменений в шагах нет — версия та же, расположение сохранено': 'No changes to steps — same version, layout saved',
    'Имя': 'Name',
    'Имя отправителя': 'Sender name',
    'Иначе': 'Else',
    'Интервал не содержит нуля: разница статистически значима.': 'The interval does not include zero: the difference is statistically significant.',
    'Интервал содержит ноль: значимой разницы пока нет.': 'The interval includes zero: no significant difference yet.',
    'Использовать': 'Use',
    'История согласований': 'Approval history',
    'Источник': 'Source',
    'Источник {name}': 'Source {name}',
    'Каждый контакт считается один раз — по первому участию в этой версии.': 'Each contact is counted once — by their first enrollment in this version.',
    'Как код': 'As code',
    'Ключ': 'Key',
    'Когда выйти досрочно': 'When to exit early',
    'Комментарий': 'Comment',
    'Комментарий (обязателен, если возвращаете)': 'Comment (required when returning)',
    'Комментарий к решению': 'Comment on the decision',
    'Комментарий:': 'Comment:',
    'Кому': 'To',
    'Конец тихих часов': 'Quiet hours end',
    'Конструктор': 'Builder',
    'Контакт': 'Contact',
    'Контакт для теста': 'Contact for the test',
    'Контекст': 'Context',
    'Контекст (JSON, необязательно)': 'Context (JSON, optional)',
    'Контекст: JSON не разбирается': 'Context: invalid JSON',
    'Контроль': 'Control',
    'Контрольная группа': 'Control group',
    'Контрольная группа (holdout), %': 'Control group (holdout), %',
    'Контрольная группа не получает писем сценария. Сравнение её доли целей с долей у получивших письма — единственный честный способ сказать, сколько добавил сценарий.': 'The control group receives no journey emails. Comparing its goal rate with the rate of those who got emails is the only honest way to say how much the journey added.',
    'Копия из браузера загружена': 'Browser copy loaded',
    'Кто может войти': 'Who can enter',
    'Кто-то сохранил новую версию — обновите страницу; ваши правки сохранены в черновике': 'Someone saved a new version — refresh the page; your edits are kept in the draft',
    'Куда': 'Where to',
    'Маркетинг': 'Marketing',
    'Маркетинг: нужно согласие, отписка, тихие часы и умная отправка': 'Marketing: requires consent, unsubscribe, quiet hours and smart sending',
    'На версию': 'To version',
    'Название': 'Name',
    'Например [{ "property": "cart_id", "op": "eq", "value": { "ref": "context.properties.cart_id" } }]': 'For example [{ "property": "cart_id", "op": "eq", "value": { "ref": "context.properties.cart_id" } }]',
    'Например total — сумма заказа для отчёта': 'For example total — the order sum for the report',
    'Например: Повторная покупка': 'For example: Repeat purchase',
    'Начало тихих часов': 'Quiet hours start',
    'Начните с шаблона — «Добро пожаловать», «Брошенная корзина» или «Возврат» — или опишите сценарий в JSON и отправьте через API из CI.': 'Start from a template: «Welcome», «Abandoned cart» or «Return» — or describe the journey in JSON and send it via the API from CI.',
    'Не больше элементов': 'Max items',
    'Не выбрано — любой день': 'None selected — any day',
    'Не опубликован — метрик нет.': 'Not published — no metrics.',
    'Не подходит': 'Not eligible',
    'Не подходит: {r}': 'Not eligible: {r}',
    'Не позже чем через, ч': 'No later than, h',
    'Не применено: {m}': 'Not applied: {m}',
    'Не сохранено: {text}': 'Not saved: {text}',
    'Не хватает переменных: {list}': 'Missing variables: {list}',
    'Не хватает: {list}': 'Missing: {list}',
    'Нет подходящих контактов.': 'No matching contacts.',
    'Нет связи — изменения в браузере': 'No connection — changes are kept in the browser',
    'Нет согласия, подавление, лимит, опоздание': 'No consent, suppression, cap, lateness',
    'Нет эндпоинтов с событием journey.webhook — добавьте его в разделе «Вебхуки»': 'No endpoints with the journey.webhook event — add one in the «Webhooks» section',
    'Ничего не запускается сразу: сценарий создаётся черновиком, запуск — после согласования владельцем или администратором.': 'Nothing starts right away: the journey is created as a draft, and launching happens after approval by the owner or an admin.',
    'Ничего не отправляется.': 'Nothing is sent.',
    'Новые участники начнут входить сразу после запуска.': 'New contacts will start entering right after launch.',
    'Новый атрибут': 'New attribute',
    'Новый сценарий с нуля': 'New journey from scratch',
    'Обновить статистику': 'Refresh statistics',
    'Окно': 'Window',
    'Окно цели, дней': 'Goal window, days',
    'Опоздавшее письмо (например, после долгой паузы) пропускается, а не уходит невпопад.': 'A late email (for example, after a long pause) is skipped instead of being sent out of place.',
    'Остановить навсегда': 'Stop permanently',
    'Остановить сценарий навсегда': 'Stop journey permanently',
    'Остановлено MailOcean: возобновить можно после обращения в поддержку': 'Stopped by MailOcean: resume is possible only after contacting support',
    'Остановлено: завершено участий {e}, отменено писем в очереди {c}': 'Stopped: {e} enrollments ended, {c} queued emails cancelled',
    'Ответ: { "version": 3, "hash": "…", "created": true, "approval": { "status": "none" } }': 'Response: { "version": 3, "hash": "…", "created": true, "approval": { "status": "none" } }',
    'Открыть настройки цели и holdout': 'Open goal and holdout settings',
    'Отличия от работающей версии:': 'Differences from the running version:',
    'Отмена': 'Cancel',
    'Отменить все несохранённые изменения? Общий черновик удалится и у других участников команды.': 'Discard all unsaved changes? The shared draft will be deleted for other team members too.',
    'Отменить изменения': 'Discard changes',
    'Отозвать согласование': 'Revoke approval',
    'Отозвать согласование? Сценарий встанет на паузу.': 'Revoke approval? The journey will be paused.',
    'Отправитель шага': 'Step sender',
    'Пауза': 'Pause',
    'Пауза, ч': 'Pause, h',
    'Пауза: шаги ждут, новые участники не входят': 'Paused: steps wait, new contacts do not enter',
    'Первый шаг сценария': 'The journey’s first step',
    'Перезаписать моей': 'Overwrite with mine',
    'Переименование обновит все ссылки': 'Renaming updates all links',
    'Переименовать': 'Rename',
    'Переменные показаны как [имя]; ссылка отписки подставляется при отправке.': 'Variables are shown as [name]; the unsubscribe link is inserted on sending.',
    'Переменные шаблона': 'Template variables',
    'Перенесено участий: {n}': 'Enrollments moved: {n}',
    'Перенести': 'Move',
    'Перенести участия на работающую версию v{v}': 'Move enrollments to the running version v{v}',
    'Перенести участия?': 'Move enrollments?',
    'Перетащите шаг из палитры на холст или прямо на связь — он встанет в неё. Связь тянется от кружка-выхода к шагу. Нажмите на шаг — здесь откроются его настройки, на «Старт» — триггер, цель, контрольная группа, тихие часы.': 'Drag a step from the palette onto the canvas, or straight onto a connection — it will be inserted there. Drag a connection from the exit circle to a step. Click a step to open its settings here; click «Start» for the trigger, goal, control group and quiet hours.',
    'Писем не получает: только так измеряется прирост. 0 — прирост не измеряется': 'Receives no emails: this is the only way to measure lift. 0 — lift is not measured',
    'Письма ({n})': 'Emails ({n})',
    'Письма сценария за 7 дней, которые принял провайдер (не «доставлено»)': 'Journey emails from the last 7 days accepted by the provider (not «delivered»)',
    'Письма, уже переданные провайдеру, не отзываются. Для временной остановки есть «Пауза».': 'Emails already handed to the provider cannot be recalled. For a temporary stop, use «Pause».',
    'Письмо для этого контакта': 'Email for this contact',
    'Письмо шага {step}': 'Email of step {step}',
    'По умолчанию участия доходят по своей версии. Перенос сопоставляет шаги с тем же id и типом; уже выполненные шаги с письмами второй раз не исполняются.': 'By default enrollments follow their own version. The move maps steps with the same ID and type; steps with emails that already ran are not run a second time.',
    'По умолчанию — {e}': 'Default — {e}',
    'Победитель автоматически не выбирается: пересекающиеся интервалы — не повод менять сценарий.': 'No winner is picked automatically: overlapping intervals are not a reason to change the journey.',
    'Повтор': 'Repeat',
    'Повтор того же графа — created: false (безопасно для CI).': 'Same graph again — created: false (safe for CI).',
    'Повторный вход': 'Re-entry',
    'Погружение капли': 'Deep dive: a drop',
    'Подождать': 'Wait',
    'Подставляются в ожидания и цели; «кому» — номер контакта из списка или всем': 'Used in waits and goals; «to whom» is the contact number from the list, or everyone',
    'Подтверждаю: сервисные письма сценария не содержат рекламы (DAT-05)': 'I confirm: the journey’s transactional emails contain no advertising (DAT-05)',
    'Поиск контакта': 'Find a contact',
    'Поиск: email или external_id': 'Search: email or external_id',
    'Показать ещё': 'Show more',
    'Получали письма': 'Received emails',
    'Посчитать (ничего не меняет)': 'Calculate (changes nothing)',
    'Поток': 'Stream',
    'Поток и отправитель': 'Stream and sender',
    'Поток по умолчанию': 'Default stream',
    'Правила сценария': 'Journey rules',
    'Предпросмотр': 'Preview',
    'Предпросмотр письма {id}': 'Email preview {id}',
    'Предупреждения:': 'Warnings:',
    'Применить к черновику': 'Apply to draft',
    'Применённые правки попадут в черновик; новая версия — по кнопке «Сохранить версию».': 'Applied edits go to the draft; a new version is created with the «Save version» button.',
    'Пример графа:': 'Graph example:',
    'Прирост (по контрольной группе)': 'Lift (vs control group)',
    'Прирост {lift}, 95 % интервал от {a} до {b}': 'Lift {lift}, 95 % interval from {a} to {b}',
    'Причина выхода': 'Exit reason',
    'Проверить (ничего не отправляется)': 'Test (sends nothing)',
    'Проверка графа': 'Graph check',
    'Проверяется перед каждым шагом': 'Checked before each step',
    'Продолжить': 'Continue',
    'Пусто — любой контакт с триггером': 'Empty — any contact with the trigger',
    'Путь — начинается с «=»: =contact.attributes.first_name; иначе — постоянное значение': 'A path starts with “=”: =contact.attributes.first_name; otherwise it is a fixed value',
    'Расположение сохранено {time}': 'Layout saved {time}',
    'Расчёт на виртуальных часах: ни одной записи в базе и ни одного письма.': 'Calculated on virtual time: no database writes and no emails.',
    'Решение': 'Decision',
    'Решение:': 'Decision:',
    'Русский': 'Russian',
    'Ручное зачисление записывается в журнал действий. Из кода —': 'Manual enrollment is written to the activity log. From code —',
    'С версии': 'From version',
    'С нуля': 'From scratch',
    'Свойства': 'Properties',
    'Свойства события: JSON не разбирается': 'Event properties: invalid JSON',
    'Свойство ценности': 'Value property',
    'Сдвиг, дн.': 'Offset, days',
    'Сделать первым': 'Make first',
    'Сегмент': 'Segment',
    'Сейчас работает': 'Currently running',
    'Сервисное: без согласия, без тихих часов и лимитов; согласующий подтверждает, что рекламы нет': 'Transactional: no consent required, no quiet hours or caps; the approver confirms there is no advertising',
    'Симуляция показывает адреса контактов — она доступна ролям, которые могут менять сценарии.': 'The simulation shows contact addresses — it is available to roles that can edit journeys.',
    'Синтетические события': 'Synthetic events',
    'Случайные контакты, проходящие фильтр входа сценария.': 'Random contacts that pass the journey entry filter.',
    'Сначала исправьте ошибки': 'Fix the errors first',
    'Собирать событие': 'Collect event',
    'Событие': 'Event',
    'Событие цели': 'Goal event',
    'Событие-триггер': 'Trigger event',
    'Согласование': 'Approval',
    'Согласование v{v}': 'Approval v{v}',
    'Согласование отозвано, сценарий на паузе': 'Approval revoked, journey paused',
    'Согласовано самостоятельно': 'Self-approved',
    'Согласовано самостоятельно: в пространстве нет второго владельца или администратора. Это видно в истории и в MailOcean.': 'Self-approved: the workspace has no second owner or admin. This is visible in the history and to MailOcean.',
    'Согласовано — можно запускать': 'Approved — ready to launch',
    'Согласовано. Запустить может владелец или администратор.': 'Approved. The owner or an admin can launch it.',
    'Согласовать': 'Approve',
    'Согласует владелец или администратор в кабинете, потом:': 'The owner or an admin approves it in the dashboard, then:',
    'Согласующий увидит снимок: триггер, аудиторию, письма ровно закреплённых версий, частоту и время. Одобрение привязано к хешу': 'The approver sees a snapshot: trigger, audience, emails of the exact pinned versions, frequency and timing. The approval is bound to the hash',
    'Создана': 'Created',
    'Создастся черновик (версия 1) из одного шага «Выход». Ничего не отправляется: сначала соберите шаги, сохраните версию и запросите согласование.': 'A draft (version 1) with a single «Exit» step will be created. Nothing is sent: first assemble the steps, save the version and request approval.',
    'Создастся:': 'Will create:',
    'Создать и открыть редактор': 'Create and open editor',
    'Создаю…': 'Creating…',
    'Сохранена версия {v}. Чтобы запустить, запросите согласование.': 'Version {v} saved. To launch it, request approval.',
    'Сохраните версию — тест идёт по сохранённому графу.': 'Save the version — the test runs on the saved graph.',
    'Сохранить версию': 'Save version',
    'Сохраню расположение через секунду…': 'Layout will be saved in a second…',
    'Сохраню через секунду…': 'Will save in a second…',
    'Сохраняю…': 'Saving…',
    'Сплит': 'Split',
    'Сравнение': 'Comparison',
    'Срок': 'Due',
    'Старт и правила сценария': 'Start and journey rules',
    'Статистика': 'Statistics',
    'Статус': 'Status',
    'Статус участия': 'Enrollment status',
    'Строка элемента': 'Item line',
    'Сумма весов: {s} %': 'Total weight: {s} %',
    'Существующие шаблоны с тем же alias не перезаписываются.': 'Existing templates with the same alias are not overwritten.',
    'Сценариев пока нет': 'No journeys yet',
    'Сценарии': 'Journeys',
    'Сценарии как код': 'Journeys as code',
    'Сценарий из шаблона': 'Journey from template',
    'Сценарий на паузе: шаги ждут': 'Journey paused: steps are waiting',
    'Сценарий не найден': 'Journey not found',
    'Сценарий остановлен MailOcean.': 'The journey was stopped by MailOcean.',
    'Сценарий остановлен на этой версии.': 'The journey is stopped on this version.',
    'Сценарий остановлен — холст только для чтения.': 'The journey is stopped — the canvas is read-only.',
    'Сценарий с таким ключом уже есть — открываю его': 'A journey with this key already exists — opening it',
    'Сценарий снова течёт': 'The journey is flowing again',
    'Считаю…': 'Calculating…',
    'Тайм-аут': 'Timeout',
    'Такой сценарий уже есть — открываю его': 'This journey already exists — opening it',
    'Текущий шаг': 'Current step',
    'Тема:': 'Subject:',
    'Тест шага на контакте': 'Test the step on a contact',
    'Течения писем: триггер → ожидания и ветки → письма. Каждая версия запускается только после согласования владельцем или администратором; участник — капля в течении.': 'Email currents: trigger → waits and branches → emails. Each version runs only after approval by the owner or an admin; a contact is a drop in the current.',
    'Тихие часы {h}': 'Quiet hours {h}',
    'Тихие часы по времени получателя': 'Quiet hours in the recipient’s time',
    'Тогда': 'Then',
    'Тот же граф, что принимает': 'The same graph that',
    'Транзакционные': 'Transactional',
    'Триггер': 'Trigger',
    'У вас роль только для чтения.': 'Your role is read-only.',
    'У сценария нет версий.': 'The journey has no versions.',
    'У шага «{step}» есть статистика активной версии v{v} (сейчас {now}, прошло {entered}). Удалить его из черновика? Активная версия не изменится, пока новая не будет согласована и опубликована.': 'Step «{step}» has statistics for the active version v{v} (now {now}, passed {entered}). Delete it from the draft? The active version will not change until the new one is approved and published.',
    'Убрать': 'Remove',
    'Убрать {k}': 'Remove {k}',
    'Убрать событие': 'Remove event',
    'Убрать условие': 'Remove condition',
    'Уведомления по каналам ({n})': 'Channel notifications ({n})',
    'Удалить атрибуты': 'Remove attributes',
    'Удалить вариант {id}': 'Remove variant {id}',
    'Удалить условие {n}': 'Remove condition {n}',
    'Удалить шаг': 'Delete step',
    'Удалить шаг «{id}»? Ссылки на него перейдут к следующему шагу (если выход один) или станут «конец ветки».': 'Delete step «{id}»? Links to it will move to the next step (if there is one exit) or become «end of branch».',
    'Уже в сценарии': 'Already in the journey',
    'Умная отправка, ч': 'Smart sending, h',
    'Умная отправка: не слать, если недавно было письмо сценария ({h} ч)': 'Smart sending: do not send if a journey email went out recently ({h} h)',
    'Условие': 'Condition',
    'Условие {n}': 'Condition {n}',
    'Условия проверяются по порядку; первое истинное решает.': 'Conditions are checked in order; the first true one wins.',
    'Условия сценария: атрибуты, согласие, события, сегменты, а также': 'Journey conditions: attributes, consent, events, segments, and also',
    'Участие начинается с этого события контакта; тип триггера можно сменить на «Старте»': 'The enrollment starts with this contact event; the trigger type can be changed in «Start»',
    'Участие создаёт ваш сервер:': 'Your server creates the enrollment:',
    'Участий': 'Enrollments',
    'Участий нет.': 'No enrollments.',
    'Участия с {from} · в расчёте только те, у кого окно цели ({days} дн.) уже закрылось': 'Enrollments since {from} · only those whose goal window ({days} days) has already closed are counted',
    'Фильтр входа': 'Entry filter',
    'Фильтр выхода': 'Exit filter',
    'Фильтр свойств': 'Property filter',
    'Фильтр свойств (JSON)': 'Property filter (JSON)',
    'Фильтр триггера': 'Trigger filter',
    'Хеш': 'Hash',
    'Худший случай:': 'Worst case:',
    'Целей': 'Goals',
    'Цель': 'Goal',
    'Цель и контрольная группа': 'Goal and control group',
    'Цель не задана — прирост не измеряется.': 'No goal set — lift is not measured.',
    'Цель:': 'Goal:',
    'Ценность на контакт: {a} против {b} в контроле (без интервала — ориентир, не вывод)': 'Value per contact: {a} vs {b} in control (without an interval — a guide, not a conclusion)',
    'Частота': 'Frequency',
    'Часть этих людей совершила бы действие и без письма — поэтому это число не прирост.': 'Some of these people would have acted without the email — so this number is not lift.',
    'Через': 'In',
    'Через запятую': 'Comma-separated',
    'Через запятую, до 20': 'Comma-separated, up to 20',
    'Черновик загружен — правки сохраняются автоматически': 'Draft loaded — edits are saved automatically',
    'Черновик изменил(а) {by}{at} — в другой вкладке или на другом устройстве.': '{by} changed the draft{at} — in another tab or on another device.',
    'Черновик изменили': 'Draft changed',
    'Черновик изменили в другом месте': 'The draft was changed elsewhere',
    'Черновик совпал с версией и удалён': 'The draft matched the version and was removed',
    'Черновик создан: перетащите шаги из палитры на холст': 'Draft created: drag steps from the palette onto the canvas',
    'Черновик создан: проверьте шаги и запросите согласование': 'Draft created: check the steps and request approval',
    'Черновик сохраняется сам и виден команде; новая версия — по кнопке. Согласование старой версии к ней не относится.': 'The draft saves itself and is visible to the team; a new version is created with the button. Approval of the old version does not apply to it.',
    'Черновик сохранён {time}': 'Draft saved {time}',
    'Черновик: ничего не отправляется. Сохраните версию, запросите согласование — после решения владельца или администратора её можно запустить.': 'Draft: nothing is sent. Save the version and request approval — after the owner or an admin decides, it can be launched.',
    'Шаблон письма': 'Email template',
    'Шаблонов нет — создайте в разделе «Шаблоны»': 'No templates — create one in the «Templates» section',
    'Шаг': 'Step',
    'Шаг v{v}': 'Step v{v}',
    'Шаги': 'Steps',
    'Эндпоинт': 'Endpoint',
    'Эта версия активна, сценарий на паузе.': 'This version is active, the journey is paused.',
    'Эта версия работает.': 'This version is running.',
    'Язык писем:': 'Email language:',
    'без согласия {n}': 'no consent {n}',
    'в': 'at',
    'в {time}': 'at {time}',
    'в контроле': 'in control',
    'в плане, {c}': 'planned, {c}',
    'в этом браузере, от {time} (не дошёл до сервера)': 'in this browser, from {time} (did not reach the server)',
    'версия неизменяема; правка графа — новая версия': 'a version is immutable; editing the graph creates a new version',
    'все статусы': 'all statuses',
    'всего вошло {n}': 'total entered {n}',
    'всем': 'everyone',
    'вход': 'entry',
    'выключен': 'off',
    'вышли {n}': 'exited {n}',
    'данных пока мало': 'not enough data yet',
    'дата {ref}': 'date {ref}',
    'дн.': 'd.',
    'до {d}': 'until {d}',
    'добавлено:': 'added:',
    'дошли до конца': 'completed',
    'другой участник': 'another member',
    'ежегодно': 'yearly',
    'ждать': 'wait',
    'за': 'over',
    'за {n} дн.': 'over {n} d.',
    'завершить участие': 'end enrollment',
    'зависит от вызовов API или дат': 'depends on API calls or dates',
    'и': 'and',
    'и сегмент': 'and segment',
    'идти дальше': 'continue',
    'изменено шагов:': 'steps changed:',
    'изменён {ago}': 'changed {ago}',
    'как назначит сценарий': 'as the journey assigns',
    'как у сценария ({s})': 'same as journey ({s})',
    'капель в пути': 'drops en route',
    'ключ атрибута': 'attribute key',
    'конец сценария': 'end of journey',
    'контекст: { "cart_id": "c1", "cart_url": "https://…" }': 'context: { "cart_id": "c1", "cart_url": "https://…" }',
    'контроль': 'control',
    'контрольная': 'control',
    'контрольная группа': 'control group',
    'латиница в нижнем регистре, цифры, - и _, 2–64 символа': 'lowercase Latin letters, digits, - and _, 2–64 characters',
    'латиница, цифры и _, видна в журнале участия': 'Latin letters, digits and _, shown in the enrollment log',
    'латиница, цифры, - и _; по нему сценарий доступен из API': 'Latin letters, digits, - and _; the journey is available via the API by this key',
    'любой шаг': 'any step',
    'маркетинг': 'marketing',
    'мин': 'min',
    'может быть,': 'maybe',
    'на паузе': 'paused',
    'на паузе v{v}': 'paused v{v}',
    'начат от v{b}, сейчас v{v}': 'started from v{b}, now v{v}',
    'не задана': 'not set',
    'не задано': 'not set',
    'не опубликован': 'not published',
    'незначимо': 'not significant',
    'нет поля steps': 'no steps field',
    'нет — прирост не измерить': 'no — lift not measured',
    'никогда': 'never',
    'ничего не пишет': 'writes nothing',
    'один раз': 'once',
    'опоздание до {h} ч': 'lateness up to {h} h',
    'опубликована': 'published',
    'остановлен на v{v}': 'stopped at v{v}',
    'остановлена': 'stopped',
    'остаётся на v{v}': 'stays on v{v}',
    'от {f}': 'from {f}',
    'от {time}': 'from {time}',
    'от {time}, {by}': 'from {time}, {by}',
    'отправитель сценария': 'the journey sender',
    'писем за 7 дн., принято': 'emails in 7 d., accepted',
    'писем не получают': 'receive no emails',
    'по умолч.': 'default',
    'подавлены {n}': 'suppressed {n}',
    'подставляется автоматически': 'inserted automatically',
    'подходит {p}': 'eligible {p}',
    'политика': 'policy',
    'получает письма': 'receives emails',
    'после завершения': 'after exit',
    'после паузы': 'after cooldown',
    'после шага': 'after step',
    'последняя (сейчас v{v})': 'latest (now v{v})',
    'последняя v{v}': 'latest v{v}',
    'посчитано {ago}': 'calculated {ago}',
    'прирост': 'lift',
    'прирост доли целей': 'goal rate lift',
    'прирост не измеряется (нет контрольной группы)': 'lift not measured (no control group)',
    'пропуск ({r})': 'skipped ({r})',
    'пусто': 'none',
    'работает': 'running',
    'работает v{v}': 'running v{v}',
    'с ключом идемпотентности.': 'with an idempotency key.',
    'самостоятельно': 'self-approved',
    'сегмент {ref}': 'segment {ref}',
    'сервисное': 'service',
    'событие {ref}': 'event {ref}',
    'согласование:': 'approval:',
    'создаёт новую неизменяемую версию, только если граф изменился; согласовать её может только человек в кабинете (через API-ключ — нельзя). Нужны скоупы': 'creates a new immutable version only if the graph has changed; only a person in the dashboard can approve it (not through an API key). Requires the scopes',
    'сопоставлено шагов:': 'matched steps:',
    'сплит': 'split',
    'сразу': 'immediately',
    'сумма ценности': 'value sum',
    'только получающие письма, закрытые окна': 'only those receiving emails, closed windows',
    'транзакционные': 'transactional',
    'транзакционные (сервисные)': 'transactional (service)',
    'удалено:': 'removed:',
    'умная отправка {h} ч': 'smart sending {h} h',
    'участник команды': 'team member',
    'худший случай {a}': 'worst case {a}',
    'целей после письма': 'goals after email',
    'цель {ago}': 'goal {ago}',
    'ч': 'h',
    'через': 'in',
    'черновик сценария (версия 1) и шаблоны писем, которых ещё нет —': 'a journey draft (version 1) and email templates that do not exist yet —',
    'шаблон': 'template',
    'шаг': 'step',
    'шаги те же': 'same steps',
    '— выберите —': '— choose —',
    '— должна быть 100': '— must be 100',
    '— любое изменение графа потребует нового согласования.': '— any change to the graph will require a new approval.',
    'Журнал': 'Log',
    'Ждать событие': 'Wait for event',
    'Ветка': 'Branch',
    'Письмо': 'Email',
    'Уведомление': 'Notification',
    'Вебхук': 'Webhook',
    'Обновить контакт': 'Update contact',
    'Дайджест': 'Digest',
    'Выход': 'Exit',
    'Подождать срок или до местного времени контакта': 'Wait for a period or until the contact’s local time',
    'Ждать событие контакта с тайм-аутом': 'Wait for a contact event with a timeout',
    'Пойти по первому истинному условию': 'Follow the first condition that is true',
    'Разделить участников по вариантам (A/B)': 'Split enrollments across variants (A/B)',
    'Отправить письмо по закреплённой версии шаблона': 'Send an email from the pinned template version',
    'Каскад по каналам: push, Telegram, SMS, Web Push, письмо — по политике и шаблону канала': 'Cascade across channels: push, Telegram, SMS, Web Push, email — per the policy and the channel template',
    'Поставить вебхук journey.webhook вашему серверу': 'Queue a journey.webhook to your server',
    'Записать или удалить атрибуты контакта': 'Set or remove contact attributes',
    'Собрать события за окно в одно письмо': 'Collect events over a window into one email',
    'Завершить участие': 'End enrollment',
    'Течёт': 'Flowing',
    'Штиль': 'Calm',
    'Остановлено': 'Stopped',
    'Черновик': 'Draft',
    'Сценарий активен: новые участники входят, шаги выполняются': 'Journey is active: new participants join, steps run',
    'Пауза: шаги ждут, пока сценарий не возобновят': 'Paused: steps wait until the journey resumes',
    'Остановлен навсегда: участия завершены': 'Stopped for good: enrollments ended',
    'Нет опубликованной версии — ничего не отправляется': 'No published version — nothing is sent',
    'Вход в сегмент': 'Segment entry',
    'Дата из атрибута': 'Date from attribute',
    'Зачисление через API': 'Enrolled via API',
    'ожидание поставлено': 'wait scheduled',
    'ожидание закончилось': 'wait finished',
    'событие пришло': 'event received',
    'тайм-аут': 'timeout',
    'письмо поставлено в очередь': 'email queued',
    'пропуск: нет адреса': 'skipped: no address',
    'пропуск: нет согласия': 'skipped: no consent',
    'пропуск: адрес в подавлениях': 'skipped: address on the suppression list',
    'пропуск: умная отправка': 'skipped: smart sending',
    'пропуск: частотный лимит': 'skipped: frequency cap',
    'пропуск: опоздание': 'skipped: too late',
    'пропуск: ни один канал не подошёл': 'skipped: no channel matched',
    'ошибка шаблона': 'template error',
    'вебхук поставлен': 'webhook queued',
    'контакт обновлён': 'contact updated',
    'дайджест собран': 'digest assembled',
    'цель достигнута': 'goal reached',
    'вышел по фильтру выхода': 'exited by exit filter',
    'шаг «Выход»': 'the “Exit” step',
    'контроль завершён': 'control finished',
    'сценарий остановлен': 'journey stopped',
    'контакт удалён (GDPR)': 'contact deleted (GDPR)',
    'удержан': 'held',
    'ошибка': 'error',
    'перенесён в новую версию': 'moved to a new version',
    'не вошёл': 'did not enter',
    'горизонт симуляции': 'simulation horizon',
    'не подходит': 'not eligible',
    'вышел': 'exited',
    'в пути': 'in transit',
    'не запрошено': 'not requested',
    'ждёт решения': 'awaiting decision',
    'согласовано': 'approved',
    'возвращено': 'returned',
    'аннулировано': 'voided',
    'отозвано': 'revoked',
    'кабинет': 'dashboard',
    'Мобильный push': 'Mobile push',
    'Telegram-бот': 'Telegram bot',
    'сценарий на паузе': 'journey paused',
    'отправка пространства приостановлена': 'workspace sending paused',
    'отправка пространства заблокирована': 'workspace sending blocked',
    'поток приостановлен': 'stream paused',
    'глобальный стоп': 'global stop',
    'тихие часы': 'quiet hours',
    'пауза сценариев платформы': 'platform journey pause',
    'цель': 'goal',
    'фильтр выхода': 'exit filter',
    'контакт удалён': 'contact deleted',
    'перенесён': 'migrated out',
    'нет согласия': 'no consent',
    'подавление': 'suppressed',
    'отправить письмо': 'send email',
    'отправить уведомление по каналам': 'send channel notification',
    'перейти к шагу': 'go to step',
    'выйти из сценария': 'exit the journey',
    'пропустить шаг': 'skip step',
    'придержать': 'hold',
    'обновить контакт': 'update contact',
    'вызвать вебхук': 'call webhook',
    'закрыть дайджест': 'close digest',
    'ошибка шага': 'step error',
    'событие получено': 'event received',
    'шаблон не собрался': 'template did not render',
    'пропуск: нет доступного канала': 'skipped: no available channel',
    'пропуск: опоздание больше 24 ч': 'skipped: more than 24 h late',
    'время ожидания вышло': 'wait time expired',
    'ожидание завершено': 'wait finished',
    'контрольная группа — писем нет': 'control group — no emails',
    'не проходит фильтр входа': 'does not pass the entry filter',
    'ещё в пути на горизонте': 'still en route at the horizon',
    'пн': 'Mon',
    'вт': 'Tue',
    'ср': 'Wed',
    'чт': 'Thu',
    'пт': 'Fri',
    'сб': 'Sat',
    'вс': 'Sun',
    'Холст': 'Canvas',
    'Симуляция': 'Simulation',
    'Отчёт': 'Report',
    'Участия': 'Enrollments',
    'JSON': 'JSON',
    'адрес в подавлениях канала': 'address is on the channel suppression list',
    'у получателя нет адреса в этом канале': 'the recipient has no address on this channel',
    'адрес недоступен: отозван, недействителен или не подходит каналу (например, стационарный номер для SMS)': 'address unavailable: revoked, invalid or not suitable for the channel (for example, a landline number for SMS)',
    'канал не подключён или аккаунт не проверен': 'channel not connected or account not verified',
    'канал на паузе': 'channel paused',
    'нет согласия на этот канал и цель': 'no consent for this channel and purpose',
    'тихие часы получателя': 'recipient quiet hours',
    'страна номера не разрешена в настройках': 'the number’s country is not allowed in settings',
    'частотный лимит контакта': 'contact frequency cap',
    'шаг дороже потолка цены уведомления': 'step costs more than the notification price cap',
    'исчерпан дневной лимит расходов': 'daily spend limit reached',
    'в шаблоне нет варианта для этого канала': 'the template has no variant for this channel',
    'окно WhatsApp 24 ч закрыто, а шаблона Meta нет': 'WhatsApp 24 h window closed and no Meta template',
    'hello@ваш-домен': 'hello@your-domain',
  },
  uk: {
    '(обязательна в маркетинге)': '(обов’язково для маркетингу)',
    '(тема не отрисована)': '(тема не відрендерена)',
    '+{d} дн.': '+{d} дн.',
    '+{h} ч': '+{h} год',
    '+{m} мин': '+{m} хв',
    '1 ч → письмо → … — откройте любой сценарий и вкладку JSON.': '1 год → лист → … — відкрийте будь-який сценарій і вкладку JSON.',
    '20 случайных': '20 випадкових',
    '95 % интервал (Ньюкомб): {a} … {b}': '95 % інтервал (Ньюкомб): {a} … {b}',
    '95 % интервал (Уилсон)': '95 % інтервал (Вілсон)',
    '95 % интервал: {a} … {b}': '95 % інтервал: {a} … {b}',
    'Created == false, если ничего не изменилось': 'Created == false, якщо нічого не змінилося',
    'Id шага': 'ID кроку',
    'JSON (условия сценария)': 'JSON (умови сценарію)',
    'JSON не разбирается — изменение не применено': 'JSON не розбирається — зміну не застосовано',
    'email, external_id или con_…': 'email, external_id або con_…',
    'true, 42, «текст» или =путь': 'true, 42, «текст» або =шлях',
    '{a} (не найден)': '{a} (не знайдено)',
    '{g} из {e}': '{g} з {e}',
    '{label}: единица': '{label}: одиниця',
    '{n} в сегменте': '{n} у сегменті',
    '{n} изменение': '{n} зміна',
    '{n} изменений': '{n} змін',
    '{n} срабатываний за 7 дней': '{n} спрацювань за 7 днів',
    '{p} % — писем не получат': '{p} % — листів не отримають',
    '{state} v{av}. Участия в пути доходят по своей версии; новые — по v{v}.': '{state} v{av}. Учасники в дорозі йдуть за своєю версією; нові — за v{v}.',
    '{s}{v} % отн.': '{s}{v} % відн.',
    '{{свойство}} события; в письме — {{digest.items_text}} / {{{digest.items_html}}}': '{{властивість}} події; у листі — {{digest.items_text}} / {{{digest.items_html}}}',
    '«Загрузить их версию» заменит ваши несохранённые правки (вернуть их можно кнопкой «Отменить»). «Перезаписать моей» сохранит ваш вариант поверх.': '«Завантажити їхню версію» замінить ваші незбережені правки (повернути їх можна кнопкою «Скасувати зміни»). «Перезаписати моєю» збереже ваш варіант поверх.',
    'Адрес отправителя': 'Адреса відправника',
    'Активна': 'Активна',
    'Атрибут': 'Атрибут',
    'Атрибут-дата': 'Атрибут-дата',
    'Атрибутировано (не равно приросту)': 'Атрибутовано (не дорівнює приросту)',
    'Атрибуты контакта в теле': 'Атрибути контакту в тілі',
    'Аудитория (оценка)': 'Аудиторія (оцінка)',
    'Без мыши: Tab — по шагам, A — добавить, C — соединить, M — переместить, ? — все клавиши. На телефоне удобнее «Список шагов».': 'Без миші: Tab — між кроками, A — додати, C — з’єднати, M — перемістити, ? — усі клавіші. На телефоні зручніше «Список кроків».',
    'Без тихих часов': 'Без тихих годин',
    'Ближайшее такое время в поясе контакта (переходы на летнее время учтены)': 'Найближчий такий час у поясі контакту (переходи на літній час враховано)',
    'В пространстве нет второго владельца или администратора': 'У просторі немає другого власника або адміністратора',
    'Вариант': 'Варіант',
    'Вариант {id}: дальше': 'Варіант {id}: далі',
    'Вариант назначается детерминированно по контакту и сохраняется в участии.': 'Варіант призначається детерміновано для кожного контакту і зберігається в участі.',
    'Введите ключ сценария: {key}': 'Введіть ключ сценарію: {key}',
    'Вебхук ставится в очередь в транзакции шага; сценарий не ждёт ответа': 'Вебхук ставиться в чергу в транзакції кроку; сценарій не чекає на відповідь',
    'Вернуть с комментарием': 'Повернути з коментарем',
    'Версии': 'Версії',
    'Версии закреплены в хеше сценария: правка политики или шаблона потребует нового согласования.': 'Версії закріплені в хеші сценарію: правка політики або шаблону потребуватиме нового погодження.',
    'Версий ещё нет.': 'Версій ще немає.',
    'Версия': 'Версія',
    'Версия {v} ещё не согласована': 'Версію {v} ще не погоджено',
    'Версия опубликована; сценарий остаётся на паузе MailOcean': 'Версію опубліковано; сценарій лишається на паузі MailOcean',
    'Версия текста': 'Версія тексту',
    'Версия шаблона не найдена.': 'Версію шаблону не знайдено.',
    'Вес, %': 'Вага, %',
    'Возвращено автору с комментарием': 'Повернуто автору з коментарем',
    'Возобновить': 'Відновити',
    'Вошёл': 'Увійшов',
    'Вошёл {dt}': 'Увійшов {dt}',
    'вошёл': 'увійшов',
    'вошёл {dt}': 'увійшов {dt}',
    'Время': 'Час',
    'Время контакта': 'Час контакту',
    'Все сценарии': 'Усі сценарії',
    'Все участия завершатся, ожидания и таймеры удалятся, письма сценария в очереди будут отменены. Вернуть нельзя — только создать новый сценарий.': 'Усі участі завершаться, очікування й таймери буде видалено, листи сценарію в черзі буде скасовано. Повернути не можна — лише створити новий сценарій.',
    'Вставить новый шаг сюда': 'Вставити новий крок сюди',
    'Вход контакта в сегмент запускает сценарий': 'Вхід контакту в сегмент запускає сценарій',
    'Вы автор этой версии: согласовать её должен другой владелец или администратор пространства.': 'Ви автор цієї версії: погодити її має інший власник або адміністратор простору.',
    'Выберите участие слева — покажем каждый шаг с временем и исходом.': 'Оберіть участь ліворуч — покажемо кожен крок із часом і результатом.',
    'Выбрать контакты': 'Вибрати контакти',
    'Выбрать шаблон': 'Обрати шаблон',
    'Выходить при достижении цели': 'Виходити після досягнення цілі',
    'Горизонт, дн.': 'Горизонт, дн.',
    'Граф сценария в JSON': 'Граф сценарію у JSON',
    'Граф — JSON по схеме': 'Граф — JSON за схемою',
    'Группа': 'Група',
    'Дальше': 'Далі',
    'Данных пока мало: выводы делать рано.': 'Даних ще мало: висновки робити зарано.',
    'Дни недели': 'Дні тижня',
    'До 24 ч': 'До 24 год',
    'До 90 дней': 'До 90 днів',
    'До местного времени': 'До місцевого часу',
    'Добавить условие': 'Додати умову',
    'Добавьте до 20 контактов.': 'Додайте до 20 контактів.',
    'Доля': 'Частка',
    'Допустимое опоздание, ч': 'Допустиме запізнення, год',
    'Доставка': 'Доставка',
    'Единица': 'Одиниця',
    'Если письмо пропущено': 'Якщо лист пропущено',
    'Если событие пришло': 'Якщо подія надійшла',
    'Если тайм-аут': 'Якщо тайм-аут',
    'Есть несохранённые изменения': 'Є незбережені зміни',
    'Есть несохранённый черновик': 'Є незбережена чернетка',
    'Есть цель': 'Є ціль',
    'Ждать не дольше': 'Чекати не довше',
    'Ждёт решения владельца или администратора пространства.': 'Очікує рішення власника або адміністратора простору.',
    'Загружена их версия черновика': 'Завантажено їхню версію чернетки',
    'Загрузить их версию': 'Завантажити їхню версію',
    'Закрепляется при сохранении: одобряется ровно этот текст, правки шаблона потом его не меняют': 'Закріплюється під час збереження: погоджується саме цей текст; подальші правки шаблону його не змінюють',
    'Закрыть панель': 'Закрити панель',
    'Записать атрибуты': 'Записати атрибути',
    'Запрос на согласование отправлен': 'Запит на погодження надіслано',
    'Запросил': 'Запросив',
    'Запросить согласование v{v}': 'Запросити погодження v{v}',
    'Запросить согласование может участник с ролью разработчика и выше.': 'Запитувати погодження може учасник з роллю розробника і вище.',
    'Запустить v{v}': 'Запустити v{v}',
    'Запустить симуляцию': 'Запустити симуляцію',
    'Запущено: сценарий течёт': 'Запущено: сценарій тече',
    'Зачислен': 'Зараховано',
    'Зачислить': 'Зарахувати',
    'Зачислить контакт': 'Зарахувати контакт',
    'Здесь появится «погружение капли»: путь каждого контакта по шагам с временем, исходами и письмами.': 'Тут з’явиться «занурення краплі»: шлях кожного контакту крок за кроком з часом, результатами та листами.',
    'Значение {k}': 'Значення {k}',
    'Значение или путь (contact.attributes.x, context.properties.y)': 'Значення або шлях (contact.attributes.x, context.properties.y)',
    'Значение по умолчанию {name}': 'Значення за замовчуванням для {name}',
    'Из шаблона': 'З шаблону',
    'Изменений в шагах нет — версия та же, расположение сохранено': 'Змін у кроках немає — версія та сама, розташування збережено',
    'Имя': 'Ім’я',
    'Имя отправителя': 'Ім’я відправника',
    'Иначе': 'Інакше',
    'Интервал не содержит нуля: разница статистически значима.': 'Інтервал не містить нуля: різниця статистично значуща.',
    'Интервал содержит ноль: значимой разницы пока нет.': 'Інтервал містить нуль: значущої різниці поки немає.',
    'Использовать': 'Використати',
    'История согласований': 'Історія погоджень',
    'Источник': 'Джерело',
    'Источник {name}': 'Джерело {name}',
    'Каждый контакт считается один раз — по первому участию в этой версии.': 'Кожен контакт враховується один раз — за першою участю в цій версії.',
    'Как код': 'Як код',
    'Ключ': 'Ключ',
    'Когда выйти досрочно': 'Коли вийти достроково',
    'Комментарий': 'Коментар',
    'Комментарий (обязателен, если возвращаете)': 'Коментар (обов’язковий, якщо повертаєте)',
    'Комментарий к решению': 'Коментар до рішення',
    'Комментарий:': 'Коментар:',
    'Кому': 'Кому',
    'Конец тихих часов': 'Кінець тихих годин',
    'Конструктор': 'Конструктор',
    'Контакт': 'Контакт',
    'Контакт для теста': 'Контакт для тесту',
    'Контекст': 'Контекст',
    'Контекст (JSON, необязательно)': 'Контекст (JSON, необов’язково)',
    'Контекст: JSON не разбирается': 'Контекст: JSON не розбирається',
    'Контроль': 'Контроль',
    'Контрольная группа': 'Контрольна група',
    'Контрольная группа (holdout), %': 'Контрольна група (holdout), %',
    'Контрольная группа не получает писем сценария. Сравнение её доли целей с долей у получивших письма — единственный честный способ сказать, сколько добавил сценарий.': 'Контрольна група не отримує листів сценарію. Порівняння її частки цілей із часткою тих, хто отримав листи, — єдиний чесний спосіб сказати, скільки додав сценарій.',
    'Копия из браузера загружена': 'Копію з браузера завантажено',
    'Кто может войти': 'Хто може увійти',
    'Кто-то сохранил новую версию — обновите страницу; ваши правки сохранены в черновике': 'Хтось зберіг нову версію — оновіть сторінку; ваші правки збережено в чернетці',
    'Куда': 'Куди',
    'Маркетинг': 'Маркетинг',
    'Маркетинг: нужно согласие, отписка, тихие часы и умная отправка': 'Маркетинг: потрібні згода, відписка, тихі години та розумне надсилання',
    'На версию': 'До версії',
    'Название': 'Назва',
    'Например [{ "property": "cart_id", "op": "eq", "value": { "ref": "context.properties.cart_id" } }]': 'Наприклад [{ "property": "cart_id", "op": "eq", "value": { "ref": "context.properties.cart_id" } }]',
    'Например total — сумма заказа для отчёта': 'Наприклад total — сума замовлення для звіту',
    'Например: Повторная покупка': 'Наприклад: Повторна покупка',
    'Начало тихих часов': 'Початок тихих годин',
    'Начните с шаблона — «Добро пожаловать», «Брошенная корзина» или «Возврат» — или опишите сценарий в JSON и отправьте через API из CI.': 'Почніть із шаблону: «Ласкаво просимо», «Покинутий кошик» або «Повернення» — або опишіть сценарій у JSON і надішліть через API з CI.',
    'Не больше элементов': 'Не більше елементів',
    'Не выбрано — любой день': 'Не обрано — будь-який день',
    'Не опубликован — метрик нет.': 'Не опубліковано — метрик немає.',
    'Не подходит': 'Не підходить',
    'Не подходит: {r}': 'Не підходить: {r}',
    'Не позже чем через, ч': 'Не пізніше ніж через, год',
    'Не применено: {m}': 'Не застосовано: {m}',
    'Не сохранено: {text}': 'Не збережено: {text}',
    'Не хватает переменных: {list}': 'Бракує змінних: {list}',
    'Не хватает: {list}': 'Не вистачає: {list}',
    'Нет подходящих контактов.': 'Немає відповідних контактів.',
    'Нет связи — изменения в браузере': 'Немає зв’язку — зміни збережено в браузері',
    'Нет согласия, подавление, лимит, опоздание': 'Немає згоди, придушення, ліміту, запізнення',
    'Нет эндпоинтов с событием journey.webhook — добавьте его в разделе «Вебхуки»': 'Немає ендпоінтів із подією journey.webhook — додайте її в розділі «Вебхуки»',
    'Ничего не запускается сразу: сценарий создаётся черновиком, запуск — после согласования владельцем или администратором.': 'Нічого не запускається одразу: сценарій створюється як чернетка, запуск — після погодження власником або адміністратором.',
    'Ничего не отправляется.': 'Нічого не надсилається.',
    'Новые участники начнут входить сразу после запуска.': 'Нові учасники почнуть входити одразу після запуску.',
    'Новый атрибут': 'Новий атрибут',
    'Новый сценарий с нуля': 'Новий сценарій з нуля',
    'Обновить статистику': 'Оновити статистику',
    'Окно': 'Вікно',
    'Окно цели, дней': 'Вікно цілі, днів',
    'Опоздавшее письмо (например, после долгой паузы) пропускается, а не уходит невпопад.': 'Запізнілий лист (наприклад, після довгої паузи) пропускається, а не надсилається не вчасно.',
    'Остановить навсегда': 'Зупинити назавжди',
    'Остановить сценарий навсегда': 'Зупинити сценарій назавжди',
    'Остановлено MailOcean: возобновить можно после обращения в поддержку': 'Зупинено MailOcean: відновити можна лише після звернення до підтримки',
    'Остановлено: завершено участий {e}, отменено писем в очереди {c}': 'Зупинено: завершено участей — {e}, скасовано листів у черзі — {c}',
    'Ответ: { "version": 3, "hash": "…", "created": true, "approval": { "status": "none" } }': 'Відповідь: { "version": 3, "hash": "…", "created": true, "approval": { "status": "none" } }',
    'Открыть настройки цели и holdout': 'Відкрити налаштування цілі та holdout',
    'Отличия от работающей версии:': 'Відмінності від версії, що працює:',
    'Отмена': 'Скасувати',
    'Отменить все несохранённые изменения? Общий черновик удалится и у других участников команды.': 'Скасувати всі незбережені зміни? Спільну чернетку буде видалено й для інших учасників команди.',
    'Отменить изменения': 'Скасувати зміни',
    'Отозвать согласование': 'Відкликати погодження',
    'Отозвать согласование? Сценарий встанет на паузу.': 'Відкликати погодження? Сценарій буде призупинено.',
    'Отправитель шага': 'Відправник кроку',
    'Пауза': 'Пауза',
    'Пауза, ч': 'Пауза, год',
    'Пауза: шаги ждут, новые участники не входят': 'Пауза: кроки чекають, нові учасники не входять',
    'Первый шаг сценария': 'Перший крок сценарію',
    'Перезаписать моей': 'Перезаписати моєю',
    'Переименование обновит все ссылки': 'Перейменування оновить усі посилання',
    'Переименовать': 'Перейменувати',
    'Переменные показаны как [имя]; ссылка отписки подставляется при отправке.': 'Змінні показано як [назва]; посилання для відписки підставляється під час надсилання.',
    'Переменные шаблона': 'Змінні шаблону',
    'Перенесено участий: {n}': 'Перенесено участей: {n}',
    'Перенести': 'Перенести',
    'Перенести участия на работающую версию v{v}': 'Перенести учасників на версію, що працює, v{v}',
    'Перенести участия?': 'Перенести учасників?',
    'Перетащите шаг из палитры на холст или прямо на связь — он встанет в неё. Связь тянется от кружка-выхода к шагу. Нажмите на шаг — здесь откроются его настройки, на «Старт» — триггер, цель, контрольная группа, тихие часы.': 'Перетягніть крок із палітри на полотно або просто на зв’язок — він стане в нього. Зв’язок тягнеться від кружечка-виходу до кроку. Натисніть на крок — тут відкриються його налаштування, на «Старт» — тригер, ціль, контрольна група, тихі години.',
    'Писем не получает: только так измеряется прирост. 0 — прирост не измеряется': 'Не отримує листів: лише так вимірюється приріст. 0 — приріст не вимірюється',
    'Письма ({n})': 'Листи ({n})',
    'Письма сценария за 7 дней, которые принял провайдер (не «доставлено»)': 'Листи сценарію за 7 днів, які прийняв провайдер (не «доставлено»)',
    'Письма, уже переданные провайдеру, не отзываются. Для временной остановки есть «Пауза».': 'Листи, що вже передано провайдеру, не відкликаються. Для тимчасової зупинки є «Пауза».',
    'Письмо для этого контакта': 'Лист для цього контакту',
    'Письмо шага {step}': 'Лист кроку {step}',
    'По умолчанию участия доходят по своей версии. Перенос сопоставляет шаги с тем же id и типом; уже выполненные шаги с письмами второй раз не исполняются.': 'За замовчуванням учасники йдуть за своєю версією. Перенесення співставляє кроки з однаковим ID і типом; кроки з листами, які вже виконано, вдруге не виконуються.',
    'По умолчанию — {e}': 'За замовчуванням — {e}',
    'Победитель автоматически не выбирается: пересекающиеся интервалы — не повод менять сценарий.': 'Переможець не обирається автоматично: перетин інтервалів — не привід змінювати сценарій.',
    'Повтор': 'Повтор',
    'Повтор того же графа — created: false (безопасно для CI).': 'Повторний той самий граф — created: false (безпечно для CI).',
    'Повторный вход': 'Повторний вхід',
    'Погружение капли': 'Занурення краплі',
    'Подождать': 'Чекати',
    'Подставляются в ожидания и цели; «кому» — номер контакта из списка или всем': 'Підставляються в очікування та цілі; «кому» — номер контакту зі списку або всім',
    'Подтверждаю: сервисные письма сценария не содержат рекламы (DAT-05)': 'Підтверджую: сервісні листи сценарію не містять реклами (DAT-05)',
    'Поиск контакта': 'Пошук контакту',
    'Поиск: email или external_id': 'Пошук: email або external_id',
    'Показать ещё': 'Показати ще',
    'Получали письма': 'Отримували листи',
    'Посчитать (ничего не меняет)': 'Порахувати (нічого не змінює)',
    'Поток': 'Потік',
    'Поток и отправитель': 'Потік і відправник',
    'Поток по умолчанию': 'Потік за замовчуванням',
    'Правила сценария': 'Правила сценарію',
    'Предпросмотр': 'Попередній перегляд',
    'Предпросмотр письма {id}': 'Попередній перегляд листа {id}',
    'Предупреждения:': 'Попередження:',
    'Применить к черновику': 'Застосувати до чернетки',
    'Применённые правки попадут в черновик; новая версия — по кнопке «Сохранить версию».': 'Застосовані правки потраплять до чернетки; нова версія — кнопкою «Зберегти версію».',
    'Пример графа:': 'Приклад графа:',
    'Прирост (по контрольной группе)': 'Приріст (за контрольною групою)',
    'Прирост {lift}, 95 % интервал от {a} до {b}': 'Приріст {lift}, 95 % інтервал від {a} до {b}',
    'Причина выхода': 'Причина виходу',
    'Проверить (ничего не отправляется)': 'Перевірити (нічого не надсилається)',
    'Проверка графа': 'Перевірка графа',
    'Проверяется перед каждым шагом': 'Перевіряється перед кожним кроком',
    'Продолжить': 'Продовжити',
    'Пусто — любой контакт с триггером': 'Порожньо — будь-який контакт із тригером',
    'Путь — начинается с «=»: =contact.attributes.first_name; иначе — постоянное значение': 'Шлях починається з «=»: =contact.attributes.first_name; інакше — стале значення',
    'Расположение сохранено {time}': 'Розташування збережено {time}',
    'Расчёт на виртуальных часах: ни одной записи в базе и ни одного письма.': 'Розрахунок на віртуальному часі: жодного запису в базі й жодного листа.',
    'Решение': 'Рішення',
    'Решение:': 'Рішення:',
    'Русский': 'Російська',
    'Ручное зачисление записывается в журнал действий. Из кода —': 'Ручне зарахування записується в журнал дій. З коду —',
    'С версии': 'З версії',
    'С нуля': 'З нуля',
    'Свойства': 'Властивості',
    'Свойства события: JSON не разбирается': 'Властивості події: JSON не розбирається',
    'Свойство ценности': 'Властивість цінності',
    'Сдвиг, дн.': 'Зсув, дн.',
    'Сделать первым': 'Зробити першим',
    'Сегмент': 'Сегмент',
    'Сейчас работает': 'Зараз працює',
    'Сервисное: без согласия, без тихих часов и лимитов; согласующий подтверждает, что рекламы нет': 'Сервісне: без згоди, без тихих годин і лімітів; погоджувач підтверджує, що реклами немає',
    'Симуляция показывает адреса контактов — она доступна ролям, которые могут менять сценарии.': 'Симуляція показує адреси контактів — вона доступна ролям, які можуть змінювати сценарії.',
    'Синтетические события': 'Синтетичні події',
    'Случайные контакты, проходящие фильтр входа сценария.': 'Випадкові контакти, що проходять фільтр входу сценарію.',
    'Сначала исправьте ошибки': 'Спочатку виправте помилки',
    'Собирать событие': 'Збирати подію',
    'Событие': 'Подія',
    'Событие цели': 'Подія мети',
    'Событие-триггер': 'Подія-тригер',
    'Согласование': 'Погодження',
    'Согласование v{v}': 'Погодження v{v}',
    'Согласование отозвано, сценарий на паузе': 'Погодження відкликано, сценарій на паузі',
    'Согласовано самостоятельно': 'Погоджено самостійно',
    'Согласовано самостоятельно: в пространстве нет второго владельца или администратора. Это видно в истории и в MailOcean.': 'Погоджено самостійно: у просторі немає другого власника або адміністратора. Це видно в історії та в MailOcean.',
    'Согласовано — можно запускать': 'Погоджено — можна запускати',
    'Согласовано. Запустить может владелец или администратор.': 'Погоджено. Запустити може власник або адміністратор.',
    'Согласовать': 'Погодити',
    'Согласует владелец или администратор в кабинете, потом:': 'Погоджує власник або адміністратор у кабінеті, потім:',
    'Согласующий увидит снимок: триггер, аудиторию, письма ровно закреплённых версий, частоту и время. Одобрение привязано к хешу': 'Погоджувач побачить знімок: тригер, аудиторію, листи точно закріплених версій, частоту й час. Погодження прив’язано до хешу',
    'Создана': 'Створено',
    'Создастся черновик (версия 1) из одного шага «Выход». Ничего не отправляется: сначала соберите шаги, сохраните версию и запросите согласование.': 'Буде створено чернетку (версія 1) з одного кроку «Вихід». Нічого не надсилається: спершу зберіть кроки, збережіть версію і запитайте погодження.',
    'Создастся:': 'Буде створено:',
    'Создать и открыть редактор': 'Створити і відкрити редактор',
    'Создаю…': 'Створюю…',
    'Сохранена версия {v}. Чтобы запустить, запросите согласование.': 'Версію {v} збережено. Щоб запустити, запитайте погодження.',
    'Сохраните версию — тест идёт по сохранённому графу.': 'Збережіть версію — тест іде за збереженим графом.',
    'Сохранить версию': 'Зберегти версію',
    'Сохраню расположение через секунду…': 'Розташування буде збережено за секунду…',
    'Сохраню через секунду…': 'Збережу за секунду…',
    'Сохраняю…': 'Зберігаю…',
    'Сплит': 'Розподіл',
    'Сравнение': 'Порівняння',
    'Срок': 'Термін',
    'Старт и правила сценария': 'Старт і правила сценарію',
    'Статистика': 'Статистика',
    'Статус': 'Статус',
    'Статус участия': 'Статус участі',
    'Строка элемента': 'Рядок елемента',
    'Сумма весов: {s} %': 'Сума ваг: {s} %',
    'Существующие шаблоны с тем же alias не перезаписываются.': 'Наявні шаблони з тим самим alias не перезаписуються.',
    'Сценариев пока нет': 'Сценаріїв ще немає',
    'Сценарии': 'Сценарії',
    'Сценарии как код': 'Сценарії як код',
    'Сценарий из шаблона': 'Сценарій із шаблону',
    'Сценарий на паузе: шаги ждут': 'Сценарій на паузі: кроки чекають',
    'Сценарий не найден': 'Сценарій не знайдено',
    'Сценарий остановлен MailOcean.': 'Сценарій зупинено MailOcean.',
    'Сценарий остановлен на этой версии.': 'Сценарій зупинено на цій версії.',
    'Сценарий остановлен — холст только для чтения.': 'Сценарій зупинено — полотно лише для читання.',
    'Сценарий с таким ключом уже есть — открываю его': 'Сценарій із таким ключем уже є — відкриваю його',
    'Сценарий снова течёт': 'Сценарій знову тече',
    'Считаю…': 'Рахую…',
    'Тайм-аут': 'Тайм-аут',
    'Такой сценарий уже есть — открываю его': 'Такий сценарій уже є — відкриваю його',
    'Текущий шаг': 'Поточний крок',
    'Тема:': 'Тема:',
    'Тест шага на контакте': 'Тест кроку на контакті',
    'Течения писем: триггер → ожидания и ветки → письма. Каждая версия запускается только после согласования владельцем или администратором; участник — капля в течении.': 'Течії листів: тригер → очікування і гілки → листи. Кожна версія запускається лише після погодження власником або адміністратором; учасник — крапля в течії.',
    'Тихие часы {h}': 'Тихі години {h}',
    'Тихие часы по времени получателя': 'Тихі години за часом отримувача',
    'Тогда': 'Тоді',
    'Тот же граф, что принимает': 'Той самий граф, що приймає',
    'Транзакционные': 'Транзакційні',
    'Триггер': 'Тригер',
    'У вас роль только для чтения.': 'Ваша роль — лише для читання.',
    'У сценария нет версий.': 'У сценарію немає версій.',
    'У шага «{step}» есть статистика активной версии v{v} (сейчас {now}, прошло {entered}). Удалить его из черновика? Активная версия не изменится, пока новая не будет согласована и опубликована.': 'У кроку «{step}» є статистика активної версії v{v} (зараз {now}, пройшло {entered}). Видалити його з чернетки? Активна версія не зміниться, доки нову не буде погоджено й опубліковано.',
    'Убрать': 'Прибрати',
    'Убрать {k}': 'Прибрати {k}',
    'Убрать событие': 'Прибрати подію',
    'Убрать условие': 'Прибрати умову',
    'Уведомления по каналам ({n})': 'Сповіщення за каналами ({n})',
    'Удалить атрибуты': 'Видалити атрибути',
    'Удалить вариант {id}': 'Видалити варіант {id}',
    'Удалить условие {n}': 'Видалити умову {n}',
    'Удалить шаг': 'Видалити крок',
    'Удалить шаг «{id}»? Ссылки на него перейдут к следующему шагу (если выход один) или станут «конец ветки».': 'Видалити крок «{id}»? Посилання на нього перейдуть до наступного кроку (якщо вихід один) або стануть «кінець гілки».',
    'Уже в сценарии': 'Уже в сценарії',
    'Умная отправка, ч': 'Розумне надсилання, год',
    'Умная отправка: не слать, если недавно было письмо сценария ({h} ч)': 'Розумне надсилання: не слати, якщо нещодавно був лист сценарію ({h} год)',
    'Условие': 'Умова',
    'Условие {n}': 'Умова {n}',
    'Условия проверяются по порядку; первое истинное решает.': 'Умови перевіряються по порядку; перша істинна вирішує.',
    'Условия сценария: атрибуты, согласие, события, сегменты, а также': 'Умови сценарію: атрибути, згода, події, сегменти, а також',
    'Участие начинается с этого события контакта; тип триггера можно сменить на «Старте»': 'Участь починається з цієї події контакту; тип тригера можна змінити в «Старті»',
    'Участие создаёт ваш сервер:': 'Участь створює ваш сервер:',
    'Участий': 'Участей',
    'Участий нет.': 'Участей немає.',
    'Участия с {from} · в расчёте только те, у кого окно цели ({days} дн.) уже закрылось': 'Участі з {from} · у розрахунку лише ті, у кого вікно цілі ({days} днів) вже закрилося',
    'Фильтр входа': 'Фільтр входу',
    'Фильтр выхода': 'Фільтр виходу',
    'Фильтр свойств': 'Фільтр властивостей',
    'Фильтр свойств (JSON)': 'Фільтр властивостей (JSON)',
    'Фильтр триггера': 'Фільтр тригера',
    'Хеш': 'Хеш',
    'Худший случай:': 'Найгірший випадок:',
    'Целей': 'Цілей',
    'Цель': 'Мета',
    'Цель и контрольная группа': 'Ціль і контрольна група',
    'Цель не задана — прирост не измеряется.': 'Ціль не задано — приріст не вимірюється.',
    'Цель:': 'Ціль:',
    'Ценность на контакт: {a} против {b} в контроле (без интервала — ориентир, не вывод)': 'Цінність на контакт: {a} проти {b} у контролі (без інтервалу — орієнтир, а не висновок)',
    'Частота': 'Частота',
    'Часть этих людей совершила бы действие и без письма — поэтому это число не прирост.': 'Частина цих людей зробила б дію і без листа — тому це число не є прирістом.',
    'Через': 'Через',
    'Через запятую': 'Через кому',
    'Через запятую, до 20': 'Через кому, до 20',
    'Черновик загружен — правки сохраняются автоматически': 'Чернетку завантажено — правки зберігаються автоматично',
    'Черновик изменил(а) {by}{at} — в другой вкладке или на другом устройстве.': '{by} змінив(ла) чернетку{at} — в іншій вкладці або на іншому пристрої.',
    'Черновик изменили': 'Чернетку змінили',
    'Черновик изменили в другом месте': 'Чернетку змінили деінде',
    'Черновик совпал с версией и удалён': 'Чернетка збіглася з версією і видалена',
    'Черновик создан: перетащите шаги из палитры на холст': 'Чернетку створено: перетягніть кроки з палітри на полотно',
    'Черновик создан: проверьте шаги и запросите согласование': 'Чернетку створено: перевірте кроки і запитайте погодження',
    'Черновик сохраняется сам и виден команде; новая версия — по кнопке. Согласование старой версии к ней не относится.': 'Чернетка зберігається сама і видима команді; нова версія — кнопкою. Погодження старої версії до неї не належить.',
    'Черновик сохранён {time}': 'Чернетку збережено {time}',
    'Черновик: ничего не отправляется. Сохраните версию, запросите согласование — после решения владельца или администратора её можно запустить.': 'Чернетка: нічого не надсилається. Збережіть версію, запросіть погодження — після рішення власника або адміністратора її можна запустити.',
    'Шаблон письма': 'Шаблон листа',
    'Шаблонов нет — создайте в разделе «Шаблоны»': 'Шаблонів немає — створіть у розділі «Шаблони»',
    'Шаг': 'Крок',
    'Шаг v{v}': 'Крок v{v}',
    'Шаги': 'Кроки',
    'Эндпоинт': 'Ендпоінт',
    'Эта версия активна, сценарий на паузе.': 'Ця версія активна, сценарій на паузі.',
    'Эта версия работает.': 'Ця версія працює.',
    'Язык писем:': 'Мова листів:',
    'без согласия {n}': 'без згоди {n}',
    'в': 'о',
    'в {time}': 'о {time}',
    'в контроле': 'у контролі',
    'в плане, {c}': 'у плані, {c}',
    'в этом браузере, от {time} (не дошёл до сервера)': 'у цьому браузері, від {time} (не дійшов до сервера)',
    'версия неизменяема; правка графа — новая версия': 'версія незмінна; правка графа — нова версія',
    'все статусы': 'усі статуси',
    'всего вошло {n}': 'усього увійшло {n}',
    'всем': 'всім',
    'вход': 'вхід',
    'выключен': 'вимкнено',
    'вышли {n}': 'вийшли {n}',
    'данных пока мало': 'даних ще мало',
    'дата {ref}': 'дата {ref}',
    'дн.': 'дн.',
    'до {d}': 'до {d}',
    'добавлено:': 'додано:',
    'дошли до конца': 'дійшли до кінця',
    'другой участник': 'інший учасник',
    'ежегодно': 'щороку',
    'ждать': 'чекати',
    'за': 'за',
    'за {n} дн.': 'за {n} дн.',
    'завершить участие': 'завершити участь',
    'зависит от вызовов API или дат': 'залежить від викликів API або дат',
    'и': 'і',
    'и сегмент': 'і сегмент',
    'идти дальше': 'продовжити',
    'изменено шагов:': 'змінено кроків:',
    'изменён {ago}': 'змінено {ago}',
    'как назначит сценарий': 'як призначить сценарій',
    'как у сценария ({s})': 'як у сценарію ({s})',
    'капель в пути': 'крапель у дорозі',
    'ключ атрибута': 'ключ атрибута',
    'конец сценария': 'кінець сценарію',
    'контекст: { "cart_id": "c1", "cart_url": "https://…" }': 'контекст: { "cart_id": "c1", "cart_url": "https://…" }',
    'контроль': 'контроль',
    'контрольная': 'контрольна',
    'контрольная группа': 'контрольна група',
    'латиница в нижнем регистре, цифры, - и _, 2–64 символа': 'латиниця в нижньому регістрі, цифри, - і _, 2–64 символи',
    'латиница, цифры и _, видна в журнале участия': 'латиниця, цифри та _, видно в журналі участі',
    'латиница, цифры, - и _; по нему сценарий доступен из API': 'латиниця, цифри, - і _; за цим ключем сценарій доступний через API',
    'любой шаг': 'будь-який крок',
    'маркетинг': 'маркетинг',
    'мин': 'хв',
    'может быть,': 'можливо,',
    'на паузе': 'на паузі',
    'на паузе v{v}': 'на паузі v{v}',
    'начат от v{b}, сейчас v{v}': 'розпочато з v{b}, зараз v{v}',
    'не задана': 'не задано',
    'не задано': 'не задано',
    'не опубликован': 'не опубліковано',
    'незначимо': 'незначуще',
    'нет поля steps': 'немає поля steps',
    'нет — прирост не измерить': 'ні — приріст не вимірюється',
    'никогда': 'ніколи',
    'ничего не пишет': 'нічого не записує',
    'один раз': 'один раз',
    'опоздание до {h} ч': 'запізнення до {h} год',
    'опубликована': 'опублікована',
    'остановлен на v{v}': 'зупинено на v{v}',
    'остановлена': 'зупинено',
    'остаётся на v{v}': 'лишається на v{v}',
    'от {f}': 'від {f}',
    'от {time}': 'від {time}',
    'от {time}, {by}': 'від {time}, {by}',
    'отправитель сценария': 'відправник сценарію',
    'писем за 7 дн., принято': 'листів за 7 дн., прийнято',
    'писем не получают': 'листів не отримують',
    'по умолч.': 'за замовч.',
    'подавлены {n}': 'придушено {n}',
    'подставляется автоматически': 'підставляється автоматично',
    'подходит {p}': 'підходить {p}',
    'политика': 'політика',
    'получает письма': 'отримує листи',
    'после завершения': 'після завершення',
    'после паузы': 'після паузи',
    'после шага': 'після кроку',
    'последняя (сейчас v{v})': 'остання (зараз v{v})',
    'последняя v{v}': 'остання v{v}',
    'посчитано {ago}': 'порахано {ago}',
    'прирост': 'приріст',
    'прирост доли целей': 'приріст частки цілей',
    'прирост не измеряется (нет контрольной группы)': 'приріст не вимірюється (немає контрольної групи)',
    'пропуск ({r})': 'пропуск ({r})',
    'пусто': 'порожньо',
    'работает': 'працює',
    'работает v{v}': 'працює v{v}',
    'с ключом идемпотентности.': 'з ключем ідемпотентності.',
    'самостоятельно': 'самостійно',
    'сегмент {ref}': 'сегмент {ref}',
    'сервисное': 'сервісне',
    'событие {ref}': 'подія {ref}',
    'согласование:': 'погодження:',
    'создаёт новую неизменяемую версию, только если граф изменился; согласовать её может только человек в кабинете (через API-ключ — нельзя). Нужны скоупы': 'створює нову незмінну версію, лише якщо граф змінився; погодити її може лише людина в кабінеті (не через API-ключ). Потрібні скоупи',
    'сопоставлено шагов:': 'зіставлено кроків:',
    'сплит': 'спліт',
    'сразу': 'одразу',
    'сумма ценности': 'сума цінності',
    'только получающие письма, закрытые окна': 'лише ті, хто отримує листи, закриті вікна',
    'транзакционные': 'транзакційні',
    'транзакционные (сервисные)': 'транзакційні (сервісні)',
    'удалено:': 'видалено:',
    'умная отправка {h} ч': 'розумне надсилання {h} год',
    'участник команды': 'учасник команди',
    'худший случай {a}': 'найгірший випадок {a}',
    'целей после письма': 'цілей після листа',
    'цель {ago}': 'ціль {ago}',
    'ч': 'год',
    'через': 'через',
    'черновик сценария (версия 1) и шаблоны писем, которых ещё нет —': 'чернетка сценарію (версія 1) і шаблони листів, яких ще немає —',
    'шаблон': 'шаблон',
    'шаг': 'крок',
    'шаги те же': 'кроки ті самі',
    '— выберите —': '— оберіть —',
    '— должна быть 100': '— має бути 100',
    '— любое изменение графа потребует нового согласования.': '— будь-яка зміна графа потребуватиме нового погодження.',
    'Журнал': 'Журнал',
    'Ждать событие': 'Чекати подію',
    'Ветка': 'Гілка',
    'Письмо': 'Лист',
    'Уведомление': 'Сповіщення',
    'Вебхук': 'Вебхук',
    'Обновить контакт': 'Оновити контакт',
    'Дайджест': 'Дайджест',
    'Выход': 'Вихід',
    'Подождать срок или до местного времени контакта': 'Чекати строк або до місцевого часу контакту',
    'Ждать событие контакта с тайм-аутом': 'Чекати подію контакту з тайм-аутом',
    'Пойти по первому истинному условию': 'Піти за першою істинною умовою',
    'Разделить участников по вариантам (A/B)': 'Розподілити учасників за варіантами (A/B)',
    'Отправить письмо по закреплённой версии шаблона': 'Надіслати лист за закріпленою версією шаблону',
    'Каскад по каналам: push, Telegram, SMS, Web Push, письмо — по политике и шаблону канала': 'Каскад за каналами: push, Telegram, SMS, Web Push, лист — за політикою та шаблоном каналу',
    'Поставить вебхук journey.webhook вашему серверу': 'Поставити вебхук journey.webhook на ваш сервер',
    'Записать или удалить атрибуты контакта': 'Записати або видалити атрибути контакту',
    'Собрать события за окно в одно письмо': 'Зібрати події за вікно в один лист',
    'Завершить участие': 'Завершити участь',
    'Течёт': 'Тече',
    'Штиль': 'Штиль',
    'Остановлено': 'Зупинено',
    'Черновик': 'Чернетка',
    'Сценарий активен: новые участники входят, шаги выполняются': 'Сценарій активний: нові учасники входять, кроки виконуються',
    'Пауза: шаги ждут, пока сценарий не возобновят': 'Пауза: кроки чекають, доки сценарій не відновлять',
    'Остановлен навсегда: участия завершены': 'Зупинено назавжди: участь завершено',
    'Нет опубликованной версии — ничего не отправляется': 'Немає опублікованої версії — нічого не надсилається',
    'Вход в сегмент': 'Вхід до сегмента',
    'Дата из атрибута': 'Дата з атрибута',
    'Зачисление через API': 'Зарахування через API',
    'ожидание поставлено': 'очікування поставлено',
    'ожидание закончилось': 'очікування завершилось',
    'событие пришло': 'подія надійшла',
    'тайм-аут': 'тайм-аут',
    'письмо поставлено в очередь': 'лист поставлено в чергу',
    'пропуск: нет адреса': 'пропуск: немає адреси',
    'пропуск: нет согласия': 'пропуск: немає згоди',
    'пропуск: адрес в подавлениях': 'пропуск: адреса в списку придушення',
    'пропуск: умная отправка': 'пропуск: розумне надсилання',
    'пропуск: частотный лимит': 'пропуск: частотний ліміт',
    'пропуск: опоздание': 'пропуск: запізнення',
    'пропуск: ни один канал не подошёл': 'пропуск: жоден канал не підійшов',
    'ошибка шаблона': 'помилка шаблону',
    'вебхук поставлен': 'вебхук поставлено',
    'контакт обновлён': 'контакт оновлено',
    'дайджест собран': 'дайджест зібрано',
    'цель достигнута': 'ціль досягнуто',
    'вышел по фильтру выхода': 'вийшов за фільтром виходу',
    'шаг «Выход»': 'крок «Вихід»',
    'контроль завершён': 'контроль завершено',
    'сценарий остановлен': 'сценарій зупинено',
    'контакт удалён (GDPR)': 'контакт видалено (GDPR)',
    'удержан': 'утримано',
    'ошибка': 'помилка',
    'перенесён в новую версию': 'перенесено до нової версії',
    'не вошёл': 'не увійшов',
    'горизонт симуляции': 'горизонт симуляції',
    'не подходит': 'не підходить',
    'вышел': 'вийшов',
    'в пути': 'у дорозі',
    'не запрошено': 'не запитано',
    'ждёт решения': 'очікує рішення',
    'согласовано': 'погоджено',
    'возвращено': 'повернуто',
    'аннулировано': 'анульовано',
    'отозвано': 'відкликано',
    'кабинет': 'кабінет',
    'Мобильный push': 'Мобільний push',
    'Telegram-бот': 'Telegram-бот',
    'сценарий на паузе': 'сценарій на паузі',
    'отправка пространства приостановлена': 'надсилання простору призупинено',
    'отправка пространства заблокирована': 'надсилання простору заблоковано',
    'поток приостановлен': 'потік призупинено',
    'глобальный стоп': 'глобальна зупинка',
    'тихие часы': 'тихі години',
    'пауза сценариев платформы': 'пауза сценаріїв платформи',
    'цель': 'ціль',
    'фильтр выхода': 'фільтр виходу',
    'контакт удалён': 'контакт видалено',
    'перенесён': 'перенесено',
    'нет согласия': 'немає згоди',
    'подавление': 'придушення',
    'отправить письмо': 'надіслати лист',
    'отправить уведомление по каналам': 'надіслати сповіщення за каналами',
    'перейти к шагу': 'перейти до кроку',
    'выйти из сценария': 'вийти зі сценарію',
    'пропустить шаг': 'пропустити крок',
    'придержать': 'утримати',
    'обновить контакт': 'оновити контакт',
    'вызвать вебхук': 'викликати вебхук',
    'закрыть дайджест': 'закрити дайджест',
    'ошибка шага': 'помилка кроку',
    'событие получено': 'подію отримано',
    'шаблон не собрался': 'шаблон не зібрався',
    'пропуск: нет доступного канала': 'пропуск: немає доступного каналу',
    'пропуск: опоздание больше 24 ч': 'пропуск: запізнення більше 24 год',
    'время ожидания вышло': 'час очікування минув',
    'ожидание завершено': 'очікування завершено',
    'контрольная группа — писем нет': 'контрольна група — листів немає',
    'не проходит фильтр входа': 'не проходить фільтр входу',
    'ещё в пути на горизонте': 'ще в дорозі на горизонті',
    'пн': 'пн',
    'вт': 'вт',
    'ср': 'ср',
    'чт': 'чт',
    'пт': 'пт',
    'сб': 'сб',
    'вс': 'нд',
    'Холст': 'Полотно',
    'Симуляция': 'Симуляція',
    'Отчёт': 'Звіт',
    'Участия': 'Участі',
    'JSON': 'JSON',
    'адрес в подавлениях канала': 'адреса в списку придушення каналу',
    'у получателя нет адреса в этом канале': 'у одержувача немає адреси в цьому каналі',
    'адрес недоступен: отозван, недействителен или не подходит каналу (например, стационарный номер для SMS)': 'адреса недоступна: відкликана, недійсна або не підходить для каналу (наприклад, стаціонарний номер для SMS)',
    'канал не подключён или аккаунт не проверен': 'канал не підключено або акаунт не перевірено',
    'канал на паузе': 'канал на паузі',
    'нет согласия на этот канал и цель': 'немає згоди на цей канал і мету',
    'тихие часы получателя': 'тихі години одержувача',
    'страна номера не разрешена в настройках': 'країну номера не дозволено в налаштуваннях',
    'частотный лимит контакта': 'частотний ліміт контакту',
    'шаг дороже потолка цены уведомления': 'крок дорожчий за стелю ціни сповіщення',
    'исчерпан дневной лимит расходов': 'денний ліміт витрат вичерпано',
    'в шаблоне нет варианта для этого канала': 'у шаблоні немає варіанта для цього каналу',
    'окно WhatsApp 24 ч закрыто, а шаблона Meta нет': 'вікно WhatsApp 24 год закрито, а шаблону Meta немає',
    'hello@ваш-домен': 'hello@ваш-домен',
  },
};
